export default "__VITE_ASSET__b01765e6__"